import { GroupPointRanking } from './GroupPointRanking';

/**
 * Class representing a team point ranking.
 * @extends GroupPointRanking
 */
export class TeamPointRanking extends GroupPointRanking {}
